import React, { useState } from "react";
import { Grid2 as Grid, Accordion, AccordionSummary, AccordionDetails, Box, Chip } from "@mui/material";
import { ExpandMore, AddCircleOutline } from "@mui/icons-material";
import { CustomControlledInput } from "./CustomControlledInput";
import { BoxSpaceCenter } from "../style/box";
import { RegisterButton } from "../style/button";
import { TypographyBold } from "../style/typography";

const PartnerCompanyRegistration = ({ control, facilities, openDialog, handleRegistSubmit, expanded = false, isDisabled }) => {
  const [isExpanded, setIsExpanded] = useState(expanded);

  return (
    <Grid size={{ xs: 12 }}>
      <Accordion expanded={isExpanded} onChange={() => setIsExpanded(!isExpanded)}>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="partner-company-registration-content"
          id="partner-company-registration-header"
        >
          <TypographyBold>新規連絡先会社登録</TypographyBold>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={3}>
            {/* 連絡先会社名 */}
            <Grid size={{ xs: 12, md: 6 }}>
              <CustomControlledInput
                name="registPartnerCompany.name"
                control={control}
                label="連絡先会社名"
                placeholder="連絡先会社名"
                inputProps={{ maxLength: 100 }}
                disabled={isDisabled}
              />
            </Grid>
            {/* 担当発電所 */}
            <Grid size={{ xs: 12, md: 6 }}>
              <CustomControlledInput
                name="registPartnerCompany.facilities"
                control={control}
                label="担当発電所"
                type="select"
                multiple
                options={facilities.map(p => ({ value: p.uuid, label: p.name }))}
                disabled={isDisabled}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((val) => {
                      const plant = facilities.find((p) => p.uuid === val);
                      return <Chip key={val} label={plant?.name || val} size="small" />;
                    })}
                  </Box>
                )}
              />
            </Grid>
            {/* 登録ボタン */}
            <Grid container size={{ xs: 12 }} justifyContent="center">
              <Grid size={{ xs: 12, md: 6 }}>
                <BoxSpaceCenter>
                  <form
                    style={{ width: "100%" }}
                    onSubmit={handleRegistSubmit((data) => { openDialog('register', data.registPartnerCompany); })}
                  >
                    <RegisterButton
                      fullWidth
                      type="submit"
                      variant="contained"
                      startIcon={<AddCircleOutline />}
                      disabled={isDisabled}
                    >
                      連絡先会社を登録
                    </RegisterButton>
                  </form>
                </BoxSpaceCenter>
              </Grid>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};

export default PartnerCompanyRegistration;